import { Byte } from "../../utils/Byte";
import { BinHashUtils } from "./BinHashUtils";
import { JsonBinRead } from "./JsonBinRead";
export class JsonBinWrite {
    static get instance() {
        return JsonBinWrite._instance || (JsonBinWrite._instance = new JsonBinWrite());
    }
    constructor() {
        this.objectRef = {};
        this.deep = 0;
    }
    _saveKey(key, valueType, keyMap, out) {
        this.deep++;
        var keysv = key + "/&&__*?/" + valueType;
        var keyNum = keyMap.keys[keysv];
        if (!keyNum) {
            keyNum = keyMap.keys[keysv] = keyMap.keyIndex;
            keyMap.strs.push(key, valueType);
            keyMap.keyIndex++;
        }
        out.writeUint16(keyNum);
        this.deep--;
    }
    _getValueArrayType(value) {
        switch (typeof (value)) {
            case "number":
                if (Math.floor(value) !== value)
                    return JsonBinRead.ARRAYDOUBLE;
                var valueabs = Math.abs(value);
                if (valueabs < 128)
                    return JsonBinRead.ARRAYNUM8;
                if (valueabs < 0x7FFF)
                    return JsonBinRead.ARRAYNUM16;
                return JsonBinRead.ARRAYNUM32;
            case "string":
                return JsonBinRead.OBJECT;
            case "boolean":
                return JsonBinRead.BOOLEAN;
        }
        return JsonBinRead.OBJECT;
    }
    _writeStrOrWordText(keyMap, key, value, out, isWordText) {
        var type = isWordText ? JsonBinRead.WORDTEXT : JsonBinRead.STRING;
        (key != null) ? (this._saveKey(key, type, keyMap, out)) : (out.writeUint8(type));
        var keyNum = keyMap.keys[value];
        if (!keyNum) {
            keyNum = keyMap.keys[value] = keyMap.keyIndex;
            keyMap.strs.push(value, 0);
            keyMap.keyIndex++;
        }
        out.writeUint16(keyNum);
    }
    _writeString(keyMap, value, out) {
        var keyNum = keyMap.keys[value];
        if (!keyNum) {
            keyNum = keyMap.keys[value] = keyMap.keyIndex;
            keyMap.strs.push(value, 0);
            keyMap.keyIndex++;
        }
        out.writeUint16(keyNum);
    }
    _getObjectTypeof(value) {
        if (value instanceof ArrayBuffer)
            return "ArrayBuffer";
        if (value instanceof Uint8Array)
            return "Uint8Array";
        if (value instanceof Int8Array)
            return "Int8Array";
        if (value instanceof Int16Array)
            return "Int16Array";
        if (value instanceof Float32Array)
            return "Float32Array";
        if ((value instanceof WordText) || JsonBinWrite.isWordText(value))
            return "WordText";
        return "object";
    }
    static isWordText(o) {
        return o && o._text && (o._$_$ISWORDTYEXT || o.lastGCCnt != null);
    }
    _writeLen(out, len) {
        if (len < 0x80)
            out.writeUint8(len);
        else if (len < 0x8000) {
            out.writeUint8((len >> 8) | 0x80);
            out.writeUint8(len & 0xFF);
        }
        else
            throw "jsonbin save len must<0x8000" + " " + len;
    }
    _writeBigNumber(out, value) {
        let numstr = value.toString(16);
        let n1 = parseInt(numstr.substring(0, numstr.length - 7), 16);
        let n2 = parseInt(numstr.substring(numstr.length - 7), 16);
        out.writeInt32(n1);
        out.writeInt32(n2);
        if (JsonBinRead._toLargeNumber(n1, n2) != value)
            throw "save big number err:" + value;
    }
    _writeOne(out, keyMap, key, value, parent) {
        if (value == undefined) {
            return false;
        }
        let type = typeof (value);
        if (type == "object" && value) {
            if (value.$__$disbaleJsonBinSv) {
                if (value.$__$disbaleJsonBinSv == JsonBinWrite.NOSAVETHISOBJ_DELETE) {
                }
                return false;
            }
            type = this._getObjectTypeof(value);
        }
        switch (type) {
            case "number":
                if (Math.floor(value) !== value) {
                    var value1000 = value * 1000;
                    if ((value1000 | 0) === value1000) {
                        if (Math.abs(value) < 32) {
                            (key != null) ? this._saveKey(key, JsonBinRead.NUM16_1000, keyMap, out) : out.writeUint8(JsonBinRead.NUM16_1000);
                            out.writeInt16(value1000);
                            return true;
                        }
                        if (Math.abs(value) < 2147483) {
                            (key != null) ? this._saveKey(key, JsonBinRead.NUM32_1000, keyMap, out) : out.writeUint8(JsonBinRead.NUM32_1000);
                            out.writeInt32(value1000);
                            return true;
                        }
                    }
                    (key != null) ? this._saveKey(key, JsonBinRead.DOUBLE, keyMap, out) : out.writeUint8(JsonBinRead.DOUBLE);
                    out.writeFloat32(value);
                    return true;
                }
                var valueabs = Math.abs(value);
                if (valueabs < 128) {
                    (key != null) ? this._saveKey(key, JsonBinRead.NUM8, keyMap, out) : out.writeUint8(JsonBinRead.NUM8);
                    out.writeByte(value);
                    return true;
                }
                if (valueabs < 0x7FFF) {
                    (key != null) ? this._saveKey(key, JsonBinRead.NUM16, keyMap, out) : out.writeUint8(JsonBinRead.NUM16);
                    out.writeInt16(value);
                    return true;
                }
                if (valueabs < 0x7FFFFFFF) {
                    (key != null) ? this._saveKey(key, JsonBinRead.NUM32, keyMap, out) : out.writeUint8(JsonBinRead.NUM32);
                    out.writeInt32(value);
                    return true;
                }
                (key != null) ? this._saveKey(key, JsonBinRead.NUM64, keyMap, out) : out.writeUint8(JsonBinRead.NUM64);
                this._writeBigNumber(out, value);
                return true;
            case "string":
                this._writeStrOrWordText(keyMap, key, value, out, false);
                return true;
            case "boolean":
                (key != null) ? this._saveKey(key, JsonBinRead.BOOLEAN, keyMap, out) : out.writeUint8(JsonBinRead.BOOLEAN);
                out.writeByte(value ? 1 : 0);
                return true;
            case 'ArrayBuffer':
                (key != null) ? this._saveKey(key, JsonBinRead.ARRAYBUFFER32, keyMap, out) : out.writeUint8(JsonBinRead.ARRAYBUFFER32);
                out.writeUint32(value.byteLength);
                out.writeArrayBuffer(value);
                return true;
            case 'Uint8Array':
                (key != null) ? this._saveKey(key, JsonBinRead.UINT8ARRAY, keyMap, out) : out.writeUint8(JsonBinRead.UINT8ARRAY);
                this._writeLen(out, value.byteLength);
                out.writeArrayBuffer(value.buffer);
                return true;
            case 'Int8Array':
                (key != null) ? this._saveKey(key, JsonBinRead.INT8ARRAY, keyMap, out) : out.writeUint8(JsonBinRead.INT8ARRAY);
                this._writeLen(out, value.byteLength);
                out.writeArrayBuffer(value.buffer);
                return true;
            case 'Int16Array':
                (key != null) ? this._saveKey(key, JsonBinRead.INT16ARRAY, keyMap, out) : out.writeUint8(JsonBinRead.INT16ARRAY);
                this._writeLen(out, value.byteLength);
                out.writeArrayBuffer(value.buffer);
                return true;
            case 'Float32Array':
                (key != null) ? this._saveKey(key, JsonBinRead.FLOAT32ARRAY, keyMap, out) : out.writeUint8(JsonBinRead.FLOAT32ARRAY);
                this._writeLen(out, value.byteLength);
                out.writeArrayBuffer(value.buffer);
                return true;
            case 'WordText':
                this._writeStrOrWordText(keyMap, key, value._text, out, true);
                return true;
            case "object":
                break;
            default:
                throw "jsonbin no this type:" + type;
        }
        if (!value) {
            (key != null) ? this._saveKey(key, JsonBinRead.NULL, keyMap, out) : out.writeUint8(JsonBinRead.NULL);
            return true;
        }
        if (!(value instanceof Array)) {
            if (this._classEnable_ && value.__CLASS__) {
                (key != null) ? this._saveKey(key, JsonBinRead.OBJECTTHISCLASS, keyMap, out) : out.writeUint8(JsonBinRead.OBJECTTHISCLASS);
            }
            else
                (key != null) ? this._saveKey(key, JsonBinRead.OBJECT, keyMap, out) : out.writeUint8(JsonBinRead.OBJECT);
            this._writeObject(out, keyMap, value);
            out.writeUint16(JsonBinRead.OBJECTEND);
            return true;
        }
        return this._saveArray(parent, out, keyMap, key, value);
    }
    _saveArray(parent, out, keyMap, key, value) {
        var j, n = value.length;
        if (n === 0) {
            (key != null) ? this._saveKey(key, JsonBinRead.ARRAYEMPTY, keyMap, out) : out.writeUint8(JsonBinRead.ARRAYEMPTY);
            out.writeByte(0);
            return true;
        }
        var startType;
        if (n > 1 && n < 250 && ((startType = this._getValueArrayType(value[0])) != JsonBinRead.OBJECT)) {
            for (j = 1; j < n; j++) {
                if (startType !== this._getValueArrayType(value[j])) {
                    startType = JsonBinRead.OBJECT;
                    break;
                }
            }
            if (startType != JsonBinRead.OBJECT && startType != JsonBinRead.BOOLEAN) {
                (key != null) ? this._saveKey(key, startType, keyMap, out) : out.writeUint8(startType);
                out.writeUint8(value.length);
                switch (startType) {
                    case JsonBinRead.ARRAYNUM8:
                        for (j = 0; j < n; j++)
                            out.writeByte(value[j]);
                        break;
                    case JsonBinRead.ARRAYNUM16:
                        for (j = 0; j < n; j++)
                            out.writeInt16(value[j]);
                        break;
                    case JsonBinRead.ARRAYNUM32:
                        for (j = 0; j < n; j++)
                            out.writeInt32(value[j]);
                        break;
                    case JsonBinRead.ARRAYDOUBLE:
                        for (j = 0; j < n; j++)
                            out.writeFloat32(value[j]);
                        break;
                }
                return true;
            }
        }
        var typeArray;
        if (n < 250) {
            typeArray = JsonBinRead.ARRAY8;
        }
        else if (n < 32700) {
            typeArray = JsonBinRead.ARRAY16;
        }
        else {
            typeArray = JsonBinRead.ARRAY32;
        }
        var posHead = out.pos;
        (key != null) ? this._saveKey(key, typeArray, keyMap, out) : out.writeUint8(typeArray);
        var pos = out.pos, s = 0;
        switch (typeArray) {
            case JsonBinRead.ARRAY8:
                out.writeUint8(n);
                break;
            case JsonBinRead.ARRAY16:
                out.writeInt16(n);
                break;
            case JsonBinRead.ARRAY32:
                out.writeUint32(n);
                break;
        }
        var posData = out.pos;
        for (j = 0; j < n; j++) {
            if (this._writeOne(out, keyMap, null, value[j], parent))
                s++;
        }
        if (s != n) {
            var tmp = out.pos;
            out.pos = pos;
            typeArray == JsonBinRead.ARRAY8 ? out.writeUint8(s) : out.writeInt16(s);
            out.pos = tmp;
        }
        var compress;
        if (key && parent && (compress = parent[JsonBinWrite.COMPRESS + key])) {
            this._useCompress(out, keyMap, key, value, posHead, posData, compress, typeArray);
        }
        return true;
    }
    _useCompress(out, keyMap, key, value, posHead, dataPos, compress, typeArray) {
        var dLen = out.pos - dataPos;
        if (dLen < 64) {
        }
        var hashCode = BinHashUtils.getHash(out._u8d_, dataPos, dLen);
        var same;
        var src;
        var i, n;
        if (this.objectRef[hashCode]) {
            var datas = this.objectRef[hashCode];
            n = datas.length;
            for (i = 0; i < n; i++) {
                src = datas[i];
                if (src.value == value) {
                    same = src;
                    break;
                }
            }
            if (!same) {
                for (i = 0; i < n; i++) {
                    src = datas[i];
                    if (BinHashUtils.isSame(out._u8d_, src.pos, src.len, out._u8d_, dataPos, dLen)) {
                        same = src;
                        break;
                    }
                }
            }
        }
        else
            this.objectRef[hashCode] = [];
        if (!same) {
            this.objectRef[hashCode].push({ hashCode: hashCode, pos: dataPos, len: dLen, value: value });
            out.pos = posHead;
            this._saveKey(key, typeArray == JsonBinRead.ARRAY8 ? JsonBinRead.ARRAYREFSOURCE8 : JsonBinRead.ARRAYREFSOURCE16, keyMap, out);
            out.pos = dataPos + dLen;
        }
        else {
            out.pos = posHead;
            this._saveKey(key, JsonBinRead.ARRAYREF32, keyMap, out);
            out.writeByte(compress);
            out.writeUint32(same.pos);
        }
    }
    _writeObject(out, keyMap, o) {
        this._classEnable_ && o.__CLASS__ && this._writeString(keyMap, o.__CLASS__, out);
        for (var key in o) {
            if (key && key.length > JsonBinWrite.NOSAVE_KEY_LEN && key.substr(0, JsonBinWrite.NOSAVE_KEY_LEN) == JsonBinWrite.NOSAVEKEY) {
                continue;
            }
            (this._classEnable_ && key == "__CLASS__") || this._writeOne(out, keyMap, key, o[key], o);
        }
    }
    write(o, __CLASS__ = false) {
        this.deep = 0;
        this._classEnable_ = __CLASS__;
        var keyMap = new SaveKeyMap();
        this.objectRef = {};
        var out = new Byte();
        this._writeObject(out, keyMap, { top: o });
        out.writeUint16(JsonBinRead.OBJECTEND);
        var r = new Byte();
        r.writeInt32(JsonBinRead.ISJSONBIN3);
        r.writeUTFString32(keyMap.strs.join(JsonBinRead.SPLITCHAR));
        r.writeArrayBuffer(out.buffer);
        return r.buffer;
    }
}
JsonBinWrite.COMPRESS = "_$TeMpkEy$_CoMpReSs";
JsonBinWrite.NOSAVEKEY = "_$TeMpkEyNoSv$_";
JsonBinWrite.NOSAVETHISOBJ = "$__$disbaleJsonBinSv";
JsonBinWrite.NOSAVE_KEY_LEN = 15;
JsonBinWrite.NOSAVETHISOBJ_DELETE = 2;
JsonBinWrite.NOSAVETHISOBJ_TRUE = 1;
class SaveKeyMap {
    constructor() {
        this.keys = {};
        this.strs = ["BEGIN", 0];
        this.keyArray = [];
        this.keyIndex = 1;
    }
}
